var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sample-reels"},[_vm._v("作品展示")])
}
var staticRenderFns = []

export { render, staticRenderFns }